export const ReportsTableStyle = {
	wrapper: {
	background: 'var(--default-white)',
	padding: '12px',
	marginTop: '16px',
	boxShadow: 'var(--box-shadow--1)',
	borderRadius: '8px',
	flexGrow: 1,
	display: 'flex',
	flexDirection: 'column',
	},
	title: {
		color: 'var(--neutral-500)',
		flex: 1,
		fontWeight: 400,
		lineHeight: '20px',
	},
	search: {
		flex: 1,
		minWidth: '300px',
		position: 'relative',

		svg: {
			position: 'absolute',
			left: '10px',
			top: '8px',
		},

		'& .MuiFormControl-root .MuiInputBase-root input': {
			paddingLeft: '40px',

			'&::placeholder': {
				color: 'var(--neutral-500)',
			},
		},
		'& .MuiFormControl-root .MuiInputBase-root fieldset': {
			border: 0,
			background: 'var(--background-grey-op-50-1)',
		},
	},
	filterRow: {
		height: '45px',
		display: 'flex',
		alignItems: 'center',
		gap: '16px',
		marginBottom: '12px',
	},
	roleBodyRow: {
		textAlign: 'right',

		h6: {
			color: 'var(--neutral-300)',
		},

		'.MuiSelect-select': {
			padding: '8px !important',
			color: 'var(--primary-500)',
			fontSize: '14px',
		},

		'.MuiInputBase-root fieldset, .MuiInputBase-root:hover fieldset, .MuiInputBase-root.Mui-focused fieldset': {
			border: 'none',

			'&:hover': {
				border: 'none',
			},
		},
		'.MuiBox-root ': {
			marginRight: '0',
		},

		'.MuiInputBase-root svg path': {
			fill: 'var(--primary-500)',
		},
	},
	menu: {

		'&.MuiTableCell-body': {
			padding: '0 5px',
		},
	},

	menuContent: {
		width: '100%',
		padding: '8px 16px',
		textTransform: 'capitalize',
		cursor: 'pointer',

		'&:hover': {
			backgroundColor: 'var(--background-grey-op-50-1)',
		},
	},

	disabledMenuItem: {
		color: 'var(--neutral-300)',
		cursor: 'default',
	},
	activeButton: {
		background: 'var(--background-grey-op-50-1)',
		padding: '10px 16px',
		fontWeight: 400,
		svg: {
			fill: 'var(--primary-500)',
		},
	},
	button: {
		background: 'var(--background-grey-op-50-1)',
		display: 'flex',
		fontWeight: 400,
		width: '100%',
		padding: '10px 16px',
		color: 'var(--neutral-900)',
		svg: {
			fill: 'var(--neutral-900)',
		},

		'&.MuiButton-root': {},
	},
	download: {
		width: '200px',
	},
	tableStyle: {minWidth: 650},
	pageinationContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		mt: 'auto',

	},
	modalWrapper: {
		'.MuiPaper-root': {
			width: '100%',
			maxWidth: '971px',
			padding: '48px 200px 48px',
		},
	},

// tableContainer: {
//     maxHeight: '600px',
//     overflowY: 'auto',
//     overflowX: 'auto',

//     '&::-webkit-scrollbar': {
//         width: '8px !important',
//         height: '8px !important',
//     },
//     '&::-webkit-scrollbar-track': {
//         background: 'var(--background-grey-op-50-1) !important',
//         borderRadius: '8px !important',
//     },
//     '&::-webkit-scrollbar-thumb': {
//         background: 'var(--neutral-200) !important',
//         borderRadius: '8px !important',

//         '&:hover': {
//             background: 'var(--neutral-200) !important',
//         },
//     },

//     scrollbarWidth: 'thin',
//     scrollbarColor: 'var(--neutral-200) var(--background-grey-op-50-1)',
// },
tableContainer: {
    maxHeight: '600px',
    overflowY: 'auto',
    overflowX: 'auto',

    '&::-webkit-scrollbar': {
        width: '8px !important',
        height: '8px !important',
    },
    '&::-webkit-scrollbar-track': {
        background: 'var(--background-grey-op-50-1) !important',
        borderRadius: '8px !important',
    },
    '&::-webkit-scrollbar-thumb': {
        background: 'var(--neutral-200) !important',
        borderRadius: '8px !important',
    },

    scrollbarWidth: 'thin',
    scrollbarColor: 'var(--neutral-200) var(--background-grey-op-50-1)',

  },
};
